import React from "react";
import jobfinder from "../assets/Job Finder.png";

function Portfolio() {
  const projects = [
    {
      title: "Project One",
      description: "A brief description of Project One.",
      imageUrl: jobfinder,
    },
    {
      title: "Project Two",
      description: "A brief description of Project Two.",
      imageUrl: jobfinder,
    },
    {
      title: "Project Three",
      description: "A brief description of Project Three.",
      imageUrl: jobfinder,
    },
  ];

  return (
    <div
      id="/portfolio"
      className="bg-gradient-to-r from-indigo-400 to-purple-600 p-8 min-h-screen"
    >
      <div className="container mx-auto text-center py-10">
        <h1 className="text-4xl font-bold mb-8 text-white">Portfolio</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className="bg-white text-gray-800 p-6 rounded-lg shadow-lg transform hover:scale-105 transition duration-300 ease-in-out"
            >
              <img
                src={project.imageUrl}
                alt={project.title}
                className="mb-4 rounded-lg"
              />
              <h2 className="text-2xl font-bold mb-2">{project.title}</h2>
              <p>{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
